module.exports = __webpack_public_path__ + "static/media/righthand.a45d80a5.png";